module.exports = __webpack_public_path__ + "static/media/B1.b914c15a.png";